export const CURRENT = 'Текущая программа';
export const COMPLEETED = 'Завершенная программа';
export const DETAILS = 'Подробности';
export const ROLLUP = 'Свернуть';
export const UNKNOWN = 'Программа не определена';



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/programcard/consts.ts